<template>
    <div>
        <b-overlay rounded="sm">
            <b-card>
            <b-card-title
                class="fs-32 d-flex align-items-center justify-content-between"
            >
                <div class="d-flex align-items-center">
                <span>
                    {{ nameConfig }}
                </span>
                <b-form-checkbox
                    switch
                    class="ml-3"
                    @change="activeChatgpt()" 
                    v-model="chatgpt"
                />
                </div>
            </b-card-title> 
            </b-card>
        </b-overlay>
    </div>
</template>
<script>
import { mapActions } from 'vuex';
import makeToast from '@/mixins/makeToast';
export default {
    mixins: [makeToast],
    data() {
        return {
            chatgpt: true,
        }
    },

    props: {
        nameConfig: {
            type: String,
            required: true,
        }
    },

    mounted() {
        this.get();
    },

    methods: {
        ...mapActions('shopkeeper', ['configGpt', 'getConfig']),

        get() {
            this.getConfig()
            .then((resp) => {
                resp.data.chatgpt == 1 ?
                this.chatgpt = true :
                this.chatgpt = false;
            })
            .catch(() => { })
            .finally(() => {
            this.endloading();
            });
        },

        activeChatgpt() {
            const data = {
                chatgpt: this.chatgpt
            }
            this.configGpt(data)
            .then((resp) => {
            if (this.chatgpt == false) {
                this.makeToast(
                'sucesso!',
                'Chat GPT desabilitado'
                );
            } else {
                this.makeToast(
                'sucesso!',
                'Chat GPT habilitado!'
                );
            }
            })
            .catch(() => {
            this.makeToast(
                'Erro',
                'Houve um erro ao ocultar o Chat GPT',
                'danger'
            );
            });
        },
    }
}
</script>